export type CollectionViewMode = 'card' | 'list' | 'gallery-card' | 'search-result' | 'widget' | 'collection-search-result';
